import React from "react";
import {Container} from "react-bulma-components";
import styled from "styled-components";
import Logo from "../logo";
import {Typography} from "../typography";
import ContentBlock from "../content-block";
import HighlightsList from "../highlights-list";


const StyledContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 1rem;
`;

const Title = styled.h4`
  ${Typography.TitleBase};
  color: var(--color-blue);
  font-size: 1.4rem;
  text-align: center;
`;

const StyledHighlightsList = styled(HighlightsList)`
  width: fit-content;
  margin: 1rem auto;
  padding: 20px;
`;

const BottomFeaturesBlock = ({title, list, className})  => {
    return (
        <div className={className}>
            <ContentBlock mode='solid'
                          waveOrientation='bottomCenter' waveHeight={120} wavePosition='inset'
                          fullWidth={true}>
                <StyledContainer>
                    <Logo width={200}/>
                    <Title>{title}</Title>
                </StyledContainer>
            </ContentBlock>
            <StyledHighlightsList columns={2} {...list} />
        </div>
    )
}

export default BottomFeaturesBlock;
